(function($) {
	'use strict';
	$(function() {
		$("select").select2({
			width: '100%',
		});
	});
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/routes/admin/partials/select2.js